import { useSelector } from 'react-redux';
import LoadingIcon from '@components/LoadingIcon';
import Heading from '@components/Heading';
import { useTranslation } from 'next-i18next';
import Button from '@components/Button';
import useAuth from '@features/MyAccount/hooks/use-auth';
import NewsletterCheckbox from '../NewsletterCheckbox';
import {
  Checkbox as CheckboxClass,
  SubHeadingContainer,
  Heading as HeadingClass,
  TextBox as TextClass,
  LogOutButton,
} from '../../Information.module.css';
import { isMarketingSubscriptionActive } from '@utilities/helpers/account';
import { useCheckUserSubscriptionsQuery } from '@shared/services/common';

const ExistingUserForm = ({ control, removeUserFromMembership }) => {
  const { t } = useTranslation(['account', 'common', 'checkout']);
  const { isAuthenticated: isAuth, user = {}, isLoading } = useAuth(false);
  const { isBusiness } = useSelector((state) => state.checkout);

  const {
    data: userSubscriptionsData = [],
    isLoading: isLoadingSubscriptions,
  } = useCheckUserSubscriptionsQuery(user?.uid, {
    skip: !user?.uid,
  });

  const isMarketingActive = isMarketingSubscriptionActive(
    userSubscriptionsData
  );

  if (isLoading || isLoadingSubscriptions) {
    return <LoadingIcon withWrapper />;
  }

  return (
    <>
      {/* Welcome message */}
      <div className={SubHeadingContainer}>
        <Heading className={HeadingClass} size="extra-small">
          {t('welcome', { ns: 'common' })}
        </Heading>
        <Heading className={HeadingClass} size="extra-small">
          {isBusiness ? user.company : user.firstname}
        </Heading>
      </div>

      {/* Email */}
      <div className={SubHeadingContainer}>
        <Heading className={HeadingClass} size="super-small" hasHTML={false}>
          {t('email', { ns: 'common' })}:
        </Heading>
        <Heading className={HeadingClass} size="super-small" hasHTML={false}>
          {user.email}
        </Heading>
        {isAuth && (
          <div className={LogOutButton}>
            <Button
              type="button"
              appearance="text"
              size="extra-small"
              onClick={removeUserFromMembership}
            >
              {t('logout', { ns: 'common' })}
            </Button>
          </div>
        )}
      </div>

      {/* Business */}
      {isBusiness && (
        <div className={SubHeadingContainer}>
          <Heading className={HeadingClass} size="super-small" hasHTML={false}>
            {t('vat', { ns: 'common' })}:
          </Heading>
          <Heading className={TextClass}>{user.vat}</Heading>
        </div>
      )}

      {isMarketingActive ? null : (
        <NewsletterCheckbox className={CheckboxClass} control={control} />
      )}
    </>
  );
};

export default ExistingUserForm;
